import React from 'react'
import { Select } from 'antd'
import styles from './styles.module.scss'

const { Option } = Select

interface PropTypes {
	onSelect: Function
}

const TemplatesHeader: React.FC<PropTypes> = ({ onSelect }) => {
	const handleChange = (value: string) => {
		onSelect(value)
	}

	return (
		<header className={styles.templatesHeader}>
			<div className={styles.templatesHeader_title}>
				<h3>Templates</h3>
			</div>
			<div className={styles.templatesHeader_actions}>
				<Select
					defaultValue=''
					placeholder='Select Status'
					allowClear
					onChange={handleChange}
				>
					<Option value=''>ALL</Option>
					<Option value='DRAFT'>DRAFT</Option>
					<Option value='CREATE_REQUEST'>CREATE REQUEST</Option>
					<Option value='PENDING'>PENDING</Option>
					<Option value='REQUEST_TO_APPROVE'>REQUEST TO APPROVE</Option>
					<Option value='APPROVED'>APPROVED</Option>
					<Option value='REJECTED'>REJECTED</Option>
					<Option value='DELETE_REQUEST'>DELETE REQUEST</Option>
					<Option value='DELETED'>DELETED</Option>
					<Option value='PAUSED'>PAUSED</Option>
					<Option value='DISABLED'>DISABLED</Option>
					<Option value='FLAGGED'>FLAGGED</Option>
					<Option value='IN_APPEAL'>IN APPEAL</Option>
					<Option value='REINSTATED'>REINSTATED</Option>
				</Select>
			</div>
		</header>
	)
}

export default TemplatesHeader
